import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../models/UserFunctions.js";
import Row from "../layout/Row.js";
import Column from "../layout/Column.js";
import Divider from "../layout/Divider.js";
import Space from "../layout/Space.js";
import MLTFGPT2 from "../textfields/MLTFGPT2.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import { useSnackbar } from "notistack";
import { getFirestore, Timestamp } from "firebase/firestore";
import { addDays } from "date-fns";
import { getDocument } from "pdfjs-dist";
// Example object where you want to set the timestamp

import {
  createDoc,
  getArrayDocDataByRef,
  queryCollection,
  getDocDataByRef,
  getDocDataById,
  updateDocDataField,
  getFlutterTime,
  getOrgDataById,
} from "../models/DataFunctions.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import { set } from "date-fns";
import createNewDevis from "../api/create/createNewDevis.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import { format } from "date-fns";
import { Skeleton } from "@mui/material";
import SmallSpinner from "../loading/SmallSpinner.js";
import { useAppContext } from "../config/AppContext.js";
import sendDV1 from "../api/sign/sendDV1.js";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import { InputNumber, Spin } from "antd";
import Icon1 from "../icons/Icon.js";
import Modal1 from "../modals/Modal1.js";
import uploadDropZoneTemporary from "../api/upload/uploadDropZoneTemporary.js";
import Dropzone1 from "../dropzones/DropZone1.js";
import transferInvoiceFiles from "../api/folder/transferInvoiceFiles.js";
import FillFormModal from "../modals/FillFormModal.js";
import WarningButton from "../buttons/WarningButton.js";
import DropDownGPT1 from "../dropdowns/DropDownGPT1.js";
import DropDownGPT0 from "../dropdowns/DropDownGTP0.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import createDocApi from "../api/database/createDocApi.js";
import TextField2 from "../textfields/TextField2.js";
import TimelineNewInvoice from "../folder_modals/TimelineNewInvoice.js";
import Dropzone2 from "../dropzones/DropZone2.js";
import sendFormDevis from "../api/send/sendFormDevis.js";
import NewInvoiceForm from "./NewInvoiceForm.js";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3.js";
import TextField2T from "../textfields/TextField2T.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import RecaptchaComponent from "../embed/RecaptchaComponent.js";
import { getOrgById } from "../models/OrgFunctions.js";
import {
  audit_mpr_options,
  audit_profil_options,
} from "./folder_pages/NewFolder.js";
import MLTFGPT3 from "../textfields/MLTFGPT3.js";
import { fetchPostalCodesApi } from "../api/google_places/GooglePlacesApi.js";
import { checkAndSendTriggerEvent } from "../config/TriggerEmailSystem.js";
import { ToggleSettingsBrick } from "../textfields/EasySwitch.js";

function NewInvoiceDraft({
  userData,
  orgData,
  navigateWorkspace,
  workspaceData,
  iframe = false,
}) {
  let mobile = iframe?.deviceWidth < 768;
  const { currentUser, loading } = useAuth();
  const [client_selected = null, setClientSelected] = useState(null);
  const [client, setClient] = useState(null);
  const [master, setMaster] = useState(null);
  const [needed_files, setNeededFiles] = useState([]);
  const [clients_name_options, setClients_options] = useState([]);
  const [clients, setClients] = useState([]);
  const [article_configuration, setArticle_configuration] = useState({
    type: "",
    step: "form",
    surface: "",
    units: 1,
    surfaces: [],
    author: "",
  });
  const [audit_config, setAuditConfig] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [display_final, setDisplayFinal] = useState(false);
  // State variables to store the input values
  const [adresse_projet, setAdresse_projet] = useState("");
  const [code_postal_projet, setCode_postal_projet] = useState("");
  const [ville_projet, setVille_projet] = useState("");
  const [adresse_maitre_ouvrage, setAdresse_maitre_ouvrage] = useState("");
  const [code_postal_maitre_ouvrage, setCode_postal_maitre_ouvrage] =
    useState("");
  const [ville_maitre_ouvrage, setVille_maitre_ouvrage] = useState("");
  const [nom_maitre_ouvrage, setNom_maitre_ouvrage] = useState("");
  const [civilite_maitre_ouvrage, setCivilite_maitre_ouvrage] = useState("M.");
  const [first_name_maitre_ouvrage, setFirst_name_maitre_ouvrage] =
    useState("");
  const [email_maitre_ouvrage, setEmail_maitre_ouvrage] = useState("");
  const [telephone_maitre_ouvrage, setTelephone_maitre_ouvrage] = useState("");
  const [all_articles, setAll_articles] = useState([]);
  const [all_articles_from_approved, setAll_articles_from_approved] = useState(
    []
  );
  const [all_grouparticles_from_approved, setAll_grouparticles_from_approved] =
    useState([]);
  const [selected_articles, setSelected_articles] = useState([]);

  const [all_grouparticles, setAll_grouparticles] = useState([]);
  const [selected_grouparticles, setSelected_grouparticles] = useState([]);
  const [all_selected_articles, setAll_selected_articles] = useState([]);
  const [surface, setSurface] = useState(0);
  const [nombre_maisons, setNombre_maisons] = useState(1);

  const [loadingData, setLoadingData] = useState(false);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [tranches_surface, setTranches_surface] = useState([]);
  const [tranches_maison, setTranches_maison] = useState([]);

  const [dropped_files, setDroppedFiles] = useState([]);
  const [loading_drop = false, setLoadingDrop] = useState(false);
  const [dropped_exists, setDroppedExists] = useState(false);

  const [marque, setMarque] = useState(null);
  const [marques_options, setMarques_options] = useState([]);
  const [available_forms, setAvailable_forms] = useState([]);
  const [forms, setForms] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [forms_filled, setFormsFilled] = useState([]);

  const [type_client, setTypeClient] = useState(iframe ? "particulier" : null);

  const [step, setStep] = useState("form");
  const [comments, setComments] = useState("");

  useEffect(() => {
    checkAnyFormAvailable();
  }, [selected_articles, selected_grouparticles]);

  useEffect(() => {
    let new_all_selected_articles = [...selected_articles];
    // add articles from group articles
    selected_grouparticles.forEach((grouparticle) => {
      grouparticle.articles.forEach((article) => {
        new_all_selected_articles.push(
          all_articles.find((a) => a.id === article.id)
        );
      });
    });
    setAll_selected_articles(new_all_selected_articles);
  }, [selected_articles, selected_grouparticles]);

  const onDelete = (file) => {
    const new_files = dropped_files.filter((f) => f !== file);
    setDroppedFiles(new_files);
    if (new_files.length === 0) {
      setDroppedExists(false);
    }
  };

  const [citiesNameProjet, setCitiesNameProjet] = useState([]);
  const [postalCodesProjet, setPostalCodesProjet] = useState([]);
  const [citiesNameMaitreOuvrage, setCitiesNameMaitreOuvrage] = useState([]);
  const [postalCodesMaitreOuvrage, setPostalCodesMaitreOuvrage] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [reuse_infos, setReuseInfos] = useState(false);
  const fetchPostalCodesProjet = async (city, exact_match = false) => {
    await fetchPostalCodesApi(
      setCitiesNameProjet,
      setPostalCodesProjet,
      setCode_postal_projet,
      setLoadingSearch,
      prefix,
      city,
      exact_match,
      code_postal_projet
    );
  };

  const fetchPostalCodesMaitreOuvrage = async (city, exact_match = false) => {
    await fetchPostalCodesApi(
      setCitiesNameMaitreOuvrage,
      setPostalCodesMaitreOuvrage,
      setCode_postal_maitre_ouvrage,
      setLoadingSearch,
      prefix,
      city,
      exact_match,
      code_postal_maitre_ouvrage
    );
  };

  const checkAnyFormAvailable = () => {
    // for each form look at articles selected and if article.form_ref, then add form to available_forms
    const available_forms = [];
    const all_selected_articles = [...selected_articles];

    selected_grouparticles.forEach((grouparticle) => {
      grouparticle.articles.forEach((article) => {
        all_selected_articles.push(
          all_articles.find((a) => a.id === article.id)
        );
      });
    });

    for (let form of forms) {
      let form_available = false;
      for (let article of all_selected_articles) {
        if (article && article?.form_ref && article?.form_ref.id === form.id) {
          form_available = true;
          break;
        }
      }
      if (form_available) {
        available_forms.push(form);
      }
    }
    setAvailable_forms(available_forms);
  };

  const handleSetClient = (value) => {
    if (value === null) {
      setClientSelected(null);
      setClient(null);
      setSelected_articles([]);
      return;
    }
    let client_value = value;
    const client = clients.find((client) => client.id === client_value);
    setClientSelected(value);
    setClient(client);
    setSelected_articles([]);

    if (client && client.marques) {
      const marques_options = client.marques.map((marque) => {
        return { value: marque?.name, label: marque?.name };
      });
      setMarques_options(marques_options);
      setMarque(marques_options[0].value);
    }
  };

  const onDropZone = async (files) => {
    setLoadingDrop(true);

    let new_files = [];
    const token = await getOrRefreshFirebaseToken();

    new_files = files.filter(
      (file) => !dropped_files.map((filed) => filed?.name).includes(file?.name)
    );

    let new_drop_files = [];

    for (let i = 0; i < new_files.length; i++) {
      let res = await uploadDropZoneTemporary(
        token,
        new_files[i],
        new_files[i]?.name,
        prefix
      );
      let url = res.url;
      let name = res?.name;
      new_drop_files = [...new_drop_files, { url: url, name: name }];
    }
    let new_dropped_files = [...dropped_files, ...new_drop_files];
    setDroppedFiles(new_dropped_files);
    setDroppedExists(true);

    setLoadingDrop(false);
  };

  const transferFiles = async (invoiceid) => {
    try {
      const token = await getOrRefreshFirebaseToken();
      await transferInvoiceFiles(invoiceid, dropped_files, token, prefix);

      setDroppedFiles([]);
      setDroppedExists(false);
    } catch (error) {
      console.error("Error transfering files:", error);
    }
  };

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (!iframe && currentUser) {
      try {
        // Fetch user data

        let master = null;
        let client = null;
        let client_selected = null;
        if (!workspaceData) {
          master = orgData;
        } else if (workspaceData) {
          master = await getOrgDataById(workspaceData.master_id);
          client = orgData;
          setClient(client);
          setTypeClient("pro");
          setClientSelected(client.id);
          client_selected = client.id;
          const marques_options =
            client.marques?.map((marque) => {
              return { value: marque?.name, label: marque?.name };
            }) || [];
          setMarques_options(marques_options);
          setMarque(marques_options[0].value);
        }

        setMaster(master);
        let filtersse = [
          {
            field: "masters_id",
            operator: "array-contains",
            value: master.id,
          },
        ];

        const clients = await queryCollection("org", filtersse);
        const clients_name = clients.map((client) => {
          return { value: client.id, label: client?.name };
        });
        const sorted_clients_names = clients_name.sort((a, b) =>
          a.label.localeCompare(b.label)
        );
        setClients_options(sorted_clients_names);
        setClients(clients);

        const filters = [
          {
            field: "org_id",
            operator: "==",
            value: master.id,
          },
        ];

        let tranches_surface = orgData.infos?.remise?.surface_tranches || [];
        let tranches_maison = orgData.infos?.remise?.maison_tranches || [];
        setTranches_surface(tranches_surface);
        setTranches_maison(tranches_maison);

        const all_articles = await queryCollection("article", filters);
        const sorted_all_articles = all_articles.sort((a, b) =>
          a?.name.localeCompare(b?.name)
        );
        setAll_articles(sorted_all_articles);

        const all_grouparticles = await queryCollection(
          "grouparticle",
          filters
        );
        const sorted_all_grouparticles = all_grouparticles.sort((a, b) =>
          a?.name.localeCompare(b?.name)
        );
        let filter_visible_grouparticles = [];
        // Filter for visible grouparticles

        if (!client_selected) {
          filter_visible_grouparticles = sorted_all_grouparticles;
        } else {
          for (let grouparticle of sorted_all_grouparticles) {
            let articles = await getArrayDocDataByRef(grouparticle.articles);
            if (
              articles.some(
                (a) =>
                  a.visibility && a.visibility[client_selected.value] === true
              )
            ) {
              filter_visible_grouparticles.push(grouparticle);
            }
          }
        }

        setAll_grouparticles(filter_visible_grouparticles);
        const forms = await queryCollection("form", filters);
        setForms(forms);

        // Update state with fetched data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    if (iframe) {
      // this is within an iframe
      // the client is a particulier
      // the master is the master of the iframe based on iframe.master_id
      // the client does not exist instead use iframe.particulier infos
      // the client does not have any marques

      // the client does not have any negoces
      // the client does not have any grouparticles
      // the client does not have any forms
      // the client does not have any articles

      let master = await getOrgById(iframe.master_id);

      if (!master) {
        handleClickVariant(
          "Erreur lors de la récupération de l'organisation",
          "error"
        );

        return;
      }
      const filters = [
        {
          field: "org_id",
          operator: "==",
          value: master.id,
        },
      ];

      let tranches_surface = orgData.infos?.remise?.surface_tranches || [];
      let tranches_maison = orgData.infos?.remise?.maison_tranches || [];
      setTranches_surface(tranches_surface);
      setTranches_maison(tranches_maison);

      const all_articles = await queryCollection("article", filters);
      const sorted_all_articles = all_articles.sort((a, b) =>
        a?.name.localeCompare(b?.name)
      );
      setAll_articles(sorted_all_articles);

      setMaster(master);

      setClient(null);
      setTypeClient("particulier");
      setClientSelected(null);
      setMarques_options([]);
      setMarque(null);
      setClients_options([]);
    }
  };

  const handleCheckToStep = (step) => {
    if (step === "form") {
      if (surface === 0 && article_configuration.type === "house") {
        handleClickVariant("Veuillez saisir la surface", "error");
        return;
      }
      if (nombre_maisons === 0 && article_configuration.type === "house") {
        handleClickVariant("Veuillez saisir le nombre de maisons", "error");
        return;
      }

      setStep("infos-1");
    }
    if (step === "infos-1") {
      if (!type_client) {
        handleClickVariant("Veuillez sélectionner un type de client", "error");
        return;
      }
      if (!client && type_client === "pro") {
        handleClickVariant("Veuillez sélectionner un client", "error");
        return;
      }

      if (!nom_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le nom du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!first_name_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le nom du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!email_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir l'email du maître d'ouvrage",
          "error"
        );
        return;
      }
      // check if email is valid
      if (!email_maitre_ouvrage.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        handleClickVariant(
          "Veuillez saisir une adresse email valide.",
          "error"
        );
        return;
      }
      if (!telephone_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le téléphone du maître d'ouvrage",
          "error"
        );
        return;
      }

      setStep("infos-2");
    }

    if (step === "infos-2") {
      if (!type_client) {
        handleClickVariant("Veuillez sélectionner un type de client", "error");
        return;
      }
      if (!client && type_client === "pro") {
        handleClickVariant("Veuillez sélectionner un client", "error");
        return;
      }
      if (!adresse_projet) {
        handleClickVariant("Veuillez saisir l'adresse du projet", "error");
        return;
      }
      if (!code_postal_projet) {
        handleClickVariant("Veuillez saisir le code postal du projet", "error");
        return;
      }
      if (!ville_projet) {
        handleClickVariant("Veuillez saisir la ville du projet", "error");
        return;
      }
      if (!adresse_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir l'adresse du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!code_postal_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le code postal du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!ville_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir la ville du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!nom_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le nom du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!first_name_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le nom du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!email_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir l'email du maître d'ouvrage",
          "error"
        );
        return;
      }
      // check if email is valid
      if (!email_maitre_ouvrage.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        handleClickVariant(
          "Veuillez saisir une adresse email valide.",
          "error"
        );
        return;
      }
      if (!telephone_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le téléphone du maître d'ouvrage",
          "error"
        );
        return;
      }

      setStep("files");
    }

    if (step === "files") {
      setStep("invoice");
      createInvoice();
    }
  };

  const createInvoice = async () => {
    try {
      setLoadingData(true); // Set loading state to true

      const body = {
        org_id: master.id,
        creation_date: getFlutterTime(),
        client_id: type_client === "pro" ? client.id : null,
        state: "draft",
        nom: nom_maitre_ouvrage,
        first_name: first_name_maitre_ouvrage,

        logo_url:
          master.logo ||
          "https://i.ibb.co/CWHxrfX/Hexagone-UXLogo3-LOW-1024.png",
        champs: [],
        forms: forms_filled || [],
        master_name: master?.name,
        master_adresse: master.infos.adresse,
        master_postal: master.infos.postal,
        master_ville: master.infos.ville,
        siret: master.infos.siret,
        num_tva: master.infos.num_tva,
        phone: master.infos.phone,
        email: master.infos.email,
        num_devis: "DEV" + Math.floor(Math.random() * 1000000),
        date: format(new Date(), "dd/MM/yyyy"),
        num_cient: type_client === "pro" ? client.id : "particulier",
        date_validite: format(addDays(new Date(), 30), "dd/MM/yyyy"),
        nom_client: nom_maitre_ouvrage,
        civilite_client: civilite_maitre_ouvrage,
        adresse_client: adresse_maitre_ouvrage,
        postal_client: code_postal_maitre_ouvrage,
        ville_client: ville_maitre_ouvrage,
        adresse_projet: adresse_projet,
        postal_projet: code_postal_projet,
        ville_projet: ville_projet,
        banque: master.infos.banque,
        iban: master.infos.iban,
        bic: master.infos.bic,
        prix_tot_ttc: 0,
        politique_annulation: master.infos.politique_annulation,
        conditions_generales_vente: master.infos.conditions_generales_vente,
        conditions_reglement: master.infos.conditions_reglement,
        politique_echec: master.infos.politique_echec,
        email_client: email_maitre_ouvrage,
        tel_client: telephone_maitre_ouvrage,

        articles: [],
        surface: surface,
        nombre_maisons: nombre_maisons,
        base_ht: 0,
        supplement: 0,
        total_remise: 0,
        total_ht: 0,
        tva: 0,
        total_ttc: 0,
        marque: type_client === "pro" ? marque : "Particulier",
        client_type: client?.client_type || "particulier",
        history_events: [
          {
            date: Timestamp.now(),
            name: "Création du brouillon",
          },
        ],
        author: iframe ? "website" : orgData?.type,
        structure_type:
          article_configuration.type === "house"
            ? "maison_individuelle"
            : "extension",
        article_configuration: article_configuration,
        audit_config: audit_config,
        comments: comments,
      };

      const new_devis = await createDocApi("devis", body, prefix);
      let token = await getOrRefreshFirebaseToken();
      let author = iframe ? "website" : orgData?.type;
      await updateDocDataFieldApi(new_devis.ref, "author", author, prefix);
      // wait for the url to be generated
      let devis_generated = await getDocDataById("devis", new_devis.id);
      if (dropped_files.length > 0) {
        await transferFiles(devis_generated.id);
      }

      await checkAndSendTriggerEvent(
        ["first_devis_created"],
        orgData,
        userData,
        prefix
      );

      //const { width, height } = await getPDFDimensions(
      //  devis_generated.file.url
      //);

      handleClickVariant("Brouillon créé avec succès", "success");
      if (iframe) {
        iframe.setSuccess(true);
      } else {
        navigateWorkspace("/invoice/" + new_devis.id);
      }

      setLoadingData(false); // Set loading state to false
    } catch (error) {
      console.error("Error creating invoice:", error);
      handleClickVariant("Erreur lors de la création du devis", "error");
      setLoadingData(false); // Set loading state to false
    }
  };

  function handleSurfaceTranches() {
    for (let i = 0; i < tranches_surface.length; i++) {
      if (
        surface > tranches_surface[i].surface &&
        surface <= tranches_surface[i].surface_max
      ) {
        return tranches_surface[i].addition;
      }
    }
    return 0;
  }

  useEffect(() => {
    setSurface(article_configuration?.surface || 0);
    setNombre_maisons(article_configuration?.units || 1);

    let filterd_articles = all_articles.filter((article) => {
      let config = article.devis_form_configuration || {};
      return (
        (!config.type || config.type === article_configuration.type) &&
        (!config.extension_type ||
          article_configuration.extension_type === null ||
          config.extension_type === article_configuration.extension_type) &&
        (!config.package || config.package === article_configuration.package) &&
        (!config.pmr || config.pmr === article_configuration.pmr)
      );
    });

    let visibleee = filterd_articles.filter((a) =>
      type_client === "pro"
        ? a.visibility
          ? a.visibility[client_selected] === true
          : false
        : true
    );

    visibleee = visibleee.filter((a) =>
      iframe ? a.widget_enabled === true : true
    );

    setAll_articles_from_approved(visibleee);

    setSelected_articles(visibleee?.length > 0 ? [visibleee[0]] : []);
    // filter group articles based on form approved articles
    let filter_visible_grouparticles = [];
    for (let grouparticle of all_grouparticles) {
      let add_it = true;
      let articles = all_articles.filter((a) =>
        grouparticle.articles.map((ref) => ref.id).includes(a.id)
      );
      // I want all to be in the filterd_articles
      if (
        articles.some((a) => !filterd_articles.map((a) => a.id).includes(a.id))
      ) {
        add_it = false;
      }
      if (add_it) {
        filter_visible_grouparticles.push(grouparticle);
      }
    }
    setAll_grouparticles_from_approved(filter_visible_grouparticles);
    setSelected_grouparticles([]);
  }, [article_configuration, client_selected]);

  const [openDescription, setOpenDescription] = useState(null);

  useEffect(() => {
    if (currentUser || iframe.master_id) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [currentUser, iframe]); // Dependency array ensures this runs when currentUser changes

  // Function to create a new client
  // loading || !currentUser || !userData
  if (iframe ? false : loading || !currentUser || !userData) {
    return (
      <div className="w-full h-full overflow-auto flex flex-row">
        <SmallSpinner className="m-auto"></SmallSpinner>
      </div>
    );
  }

  return (
    <div className={`h-full overflow-auto flex min-h-c400 w-full`}>
      {/* Left Column: Takes all available space */}

      {/* Right Column: Fixed width */}
      <div className="flex flex-col gap-1 h-fit px-4 w-full ">
        <div className={`text-hx font-semibold ${mobile ? "mb-4" : ""}`}>
          Nouveau Devis
        </div>
        <div
          className={`my-6 min-h-fit max-w-c800 w-fit  ${mobile ? "hidden" : "block"}`}
        >
          <TimelineNewInvoice
            step={
              step === "form"
                ? 0
                : step === "infos-1"
                  ? 1
                  : step === "infos-2"
                    ? 1
                    : step === "infos-3"
                      ? 1
                      : step === "files"
                        ? 2
                        : 3
            }
          ></TimelineNewInvoice>
        </div>{" "}
        <div className="flex flex-row gap-4 pb-10 pr-4 w-full h-fit">
          <div className="flex flex-col gap-2 w-full ">
            {step === "infos-1" && (
              <div className="flex flex-col gap-2 max-w-c500 ">
                <div className="text-h1 font-semibold">Informations Devis</div>
                <Space y={5} />
                <div className="text-h3 text-shadow_50">
                  Remplissez les champs ci-dessous pour compléter les
                  informations du devis.
                </div>

                <div className="flex flex-row gap-2 w-full h-fit ">
                  <div className="flex xl:flex-row flex-col gap-2 w-full h-fit">
                    <div className="flex flex-col gap-2 w-full">
                      {!workspaceData && (
                        <>
                          <DropDownGPT03
                            items={[
                              {
                                value: "pro",
                                label: "Client professionnel",
                              },
                              {
                                value: "particulier",
                                label: "Client particulier",
                              },
                            ]}
                            className="w-full"
                            label="Type de client"
                            value={type_client}
                            onChange={(e) => setTypeClient(e.value)} // Update state on change
                          ></DropDownGPT03>
                          {type_client === "pro" && (
                            <DropDownGPTS3
                              items={clients_name_options}
                              className="w-full"
                              label="Client"
                              value={client_selected} // Controlled component
                              onChange={(e) => handleSetClient(e.value)}
                            ></DropDownGPTS3>
                          )}{" "}
                          {type_client === "pro" && (
                            <DropDownGPT03
                              items={marques_options}
                              className="w-full"
                              label="Marque"
                              value={marque} // Controlled component
                              onChange={(e) => setMarque(e.value)} // Update state on change
                            ></DropDownGPT03>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="w-full  flex flex-col gap-2">
                  <DropDownGPT03
                    label="Civilité du maître d'ouvrage"
                    value={civilite_maitre_ouvrage}
                    mandatory={true}
                    onChange={(e) => {
                      setCivilite_maitre_ouvrage(e.value);
                    }}
                    items={[
                      { value: "M.", label: "M." },
                      { value: "Mme", label: "Mme" },
                      { value: "Mlle", label: "Mlle" },
                      { value: "M. et Mme", label: "M et Mme" },
                      { value: "Ignorer", label: "Ignorer" },
                    ]}
                  ></DropDownGPT03>
                  <TextField2T
                    label="Nom du maître d'ouvrage"
                    mandatory={true}
                    value={nom_maitre_ouvrage}
                    onChange={(e) => setNom_maitre_ouvrage(e.target.value)}
                  ></TextField2T>{" "}
                  <TextField2T
                    label="Prénom du maître d'ouvrage"
                    mandatory={true}
                    value={first_name_maitre_ouvrage}
                    onChange={(e) =>
                      setFirst_name_maitre_ouvrage(e.target.value)
                    }
                  ></TextField2T>
                  <TextField2T
                    label="Adresse email du maître d'ouvrage"
                    mandatory={true}
                    value={email_maitre_ouvrage}
                    onChange={(e) => setEmail_maitre_ouvrage(e.target.value)}
                    type={"email"}
                  ></TextField2T>
                  <TextField2T
                    label="Téléphone personnel du maître d'ouvrage"
                    mandatory={true}
                    value={telephone_maitre_ouvrage}
                    onChange={(e) =>
                      setTelephone_maitre_ouvrage(e.target.value)
                    }
                    type="phone"
                  ></TextField2T>
                </div>
                <div className="flex flex-row justify-end w-full gap-2 mt-2">
                  {" "}
                  <SecondaryButton
                    mobile={mobile}
                    onClick={() => setStep("form")}
                  >
                    Retour
                  </SecondaryButton>
                  <PrimaryButton
                    mobile={mobile}
                    className="w-fit"
                    onClick={() => handleCheckToStep("infos-1")}
                  >
                    Continuer
                  </PrimaryButton>
                </div>
              </div>
            )}{" "}
            {step === "infos-2" && (
              <div className="flex flex-col gap-2 max-w-c500 ">
                <div className="text-h1 font-semibold">Informations Devis</div>
                <Space y={5} />
                <div className="text-h3 text-shadow_50">
                  Remplissez les champs ci-dessous pour compléter les
                  informations du devis.
                </div>

                <div className="w-full  flex flex-col gap-2">
                  <TextField2T
                    className="w-full"
                    label="Adresse actuelle du maitre d'ouvrage"
                    mandatory={true}
                    value={adresse_maitre_ouvrage}
                    onChange={(e) => setAdresse_maitre_ouvrage(e.target.value)}
                  ></TextField2T>
                  <DropDownGPTS3
                    label="Ville"
                    value={ville_maitre_ouvrage}
                    mandatory={true}
                    onChange={(e) => {
                      setVille_maitre_ouvrage(e.value);
                      fetchPostalCodesMaitreOuvrage(e.value, true);
                    }}
                    add_item={(value) => {
                      setCitiesNameMaitreOuvrage([
                        ...citiesNameMaitreOuvrage,
                        value,
                      ]);
                      setVille_maitre_ouvrage(value);
                      fetchPostalCodesMaitreOuvrage(value, true);
                    }}
                    allow_new_items={true}
                    onSearchChange={(value) => {
                      fetchPostalCodesMaitreOuvrage(value);
                    }}
                    debounceDelay={500}
                    loadingSearch={loadingSearch}
                    transparent={false}
                    items={citiesNameMaitreOuvrage.map((city) => ({
                      value: city,
                      label: city,
                    }))}
                  ></DropDownGPTS3>
                  <DropDownGPTS3
                    label="Code Postal"
                    value={code_postal_maitre_ouvrage}
                    disabled={citiesNameMaitreOuvrage.length === 0}
                    loadingSearch={loadingSearch}
                    mandatory={true}
                    onChange={(e) =>
                      setCode_postal_maitre_ouvrage(e.value || "")
                    }
                    add_item={(value) => {
                      setPostalCodesMaitreOuvrage([
                        ...postalCodesMaitreOuvrage,
                        value,
                      ]);
                      setCode_postal_maitre_ouvrage(value);
                    }}
                    allow_new_items={true}
                    transparent={false}
                    items={postalCodesMaitreOuvrage.map((code) => ({
                      value: code,
                      label: code,
                    }))}
                  ></DropDownGPTS3>{" "}
                  <Space y={10} />
                  <ToggleSettingsBrick
                    checked={reuse_infos}
                    onChange={() => {
                      setReuseInfos(!reuse_infos);
                      if (!reuse_infos) {
                        setAdresse_projet(adresse_maitre_ouvrage);
                        setCode_postal_projet(code_postal_maitre_ouvrage);
                        setVille_projet(ville_maitre_ouvrage);
                        setCitiesNameProjet([ville_maitre_ouvrage]);
                        setPostalCodesProjet([code_postal_maitre_ouvrage]);
                      } else {
                        setAdresse_projet("");
                        setCode_postal_projet("");
                        setVille_projet("");
                        setCitiesNameProjet([]);
                        setPostalCodesProjet([]);
                      }
                    }}
                    title="Réutiliser les informations"
                    description={
                      "Réutiliser les informations du maître d'ouvrage pour le projet"
                    }
                  ></ToggleSettingsBrick>
                  <Space y={10} />
                  <TextField2T
                    className="w-full"
                    label="Adresse projet"
                    mandatory={true}
                    value={adresse_projet}
                    onChange={(e) => setAdresse_projet(e.target.value)}
                    items={[
                      {
                        value: adresse_maitre_ouvrage,
                        label: adresse_maitre_ouvrage,
                      },
                    ]}
                    useSuggestedValue={() => {
                      setAdresse_projet(adresse_maitre_ouvrage);
                      setCode_postal_projet(code_postal_maitre_ouvrage);
                      setVille_projet(ville_maitre_ouvrage);
                    }}
                  ></TextField2T>
                  <DropDownGPTS3
                    label="Ville"
                    value={ville_projet}
                    mandatory={true}
                    onChange={(e) => {
                      setVille_projet(e.value);
                      fetchPostalCodesProjet(e.value, true);
                    }}
                    onSearchChange={(value) => {
                      fetchPostalCodesProjet(value);
                    }}
                    add_item={(value) => {
                      setCitiesNameProjet([...citiesNameProjet, value]);
                      setVille_projet(value);
                      fetchPostalCodesProjet(value, true);
                    }}
                    allow_new_items={true}
                    debounceDelay={500}
                    loadingSearch={loadingSearch}
                    transparent={false}
                    items={citiesNameProjet.map((city) => ({
                      value: city,
                      label: city,
                    }))}
                  ></DropDownGPTS3>
                  <DropDownGPTS3
                    label="Code Postal"
                    value={code_postal_projet}
                    disabled={citiesNameProjet.length === 0}
                    loadingSearch={loadingSearch}
                    mandatory={true}
                    add_item={(value) => {
                      setPostalCodesProjet([...postalCodesProjet, value]);
                      setCode_postal_projet(value);
                    }}
                    allow_new_items={true}
                    onChange={(e) => setCode_postal_projet(e.value || "")}
                    transparent={false}
                    items={postalCodesProjet.map((code) => ({
                      value: code,
                      label: code,
                    }))}
                  ></DropDownGPTS3>{" "}
                </div>
                <div className="flex flex-row justify-end w-full gap-2 mt-2">
                  {" "}
                  <SecondaryButton
                    mobile={mobile}
                    onClick={() => setStep("infos-1")}
                  >
                    Retour
                  </SecondaryButton>
                  <PrimaryButton
                    mobile={mobile}
                    className="w-fit"
                    onClick={() => handleCheckToStep("infos-2")}
                  >
                    Continuer
                  </PrimaryButton>
                </div>
              </div>
            )}
            {step === "files" && (
              <div className="flex flex-col max-w-c500 h-fit">
                {(!iframe || display_final) && (
                  <div className="flex flex-col max-w-c500 h-fit">
                    <div className="text-h1 font-semibold">
                      Pièces à déposer
                    </div>
                    {needed_files.length > 0 && (
                      <div className="flex flex-col gap-1 w-full mt-2">
                        {needed_files.map((file, index) => (
                          <div
                            key={index}
                            className="flex flex-col gap-2 border-l-2 border-blue-500 pl-2"
                          >
                            <div className="text-h3 text-black whitespace-pre-wrap">
                              {file.name}
                            </div>
                            <div className="text-h3 text-shadow_50 whitespace-pre-wrap">
                              {file.description}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {needed_files.length === 0 && (
                      <div className="text-h3 text-shadow_50">
                        Déposez les plans et la fiche descriptive si possible.
                        (optionnel)
                      </div>
                    )}
                    <Space y={10} />
                    <div className="flex max-h-c400 w-full">
                      <Dropzone2
                        onDrop={onDropZone}
                        files={dropped_files || []}
                        onDelete={onDelete}
                        loading={loading_drop}
                        instructionsText="Glissez ou déposez les documents ici"
                      ></Dropzone2>
                    </div>
                    {false && available_forms.length > 0 && (
                      <div className="flex flex-col gap-1 w-full">
                        <div className="text-h1 font-semibold">
                          Formulaires à remplir
                        </div>
                        <Space y={5} />
                        <div className="text-h3 text-shadow_50">
                          Remplissez les formulaires ci-dessous pour finaliser
                          le devis. Vos réponses seront enregistrées pour
                          pouvoir les réutiliser dans vos prochains devis.
                        </div>
                        <div className="flex flex-col gap-2 w-full mt-2">
                          {available_forms.map((form, index) => (
                            <div
                              className="flex flex-row justify-between w-full gap-2 bg-purple-100 px-2 py-1 rounded-lg items-center text-purple-500"
                              key={index}
                            >
                              <div className="text-h3 text-left">
                                {form.name}
                              </div>
                              <div className="flex flex-row gap-2 items-center">
                                {!forms_filled
                                  .map((f) => f.id)
                                  .includes(form.id) && (
                                  <WarningButton
                                    onClick={() => setFormOpen(form)}
                                  >
                                    Remplir
                                  </WarningButton>
                                )}
                                {forms_filled
                                  .map((f) => f.id)
                                  .includes(form.id) && (
                                  <div className="flex flex-row gap-2">
                                    <SecondaryButton
                                      mobile={mobile}
                                      onClick={() => setFormOpen(form)}
                                    >
                                      Modifier
                                    </SecondaryButton>
                                    <div className="bg-green-100 px-2 py-1 text-h3 rounded-xl text-shadow_50 ">
                                      Remplis
                                    </div>
                                  </div>
                                )}{" "}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}{" "}
                  </div>
                )}
                <MLTFGPT3
                  label={"Commentaires et instructions pour le devis"}
                  value={comments}
                  rows={6}
                  onChange={(e) => setComments(e.target.value)}
                ></MLTFGPT3>
                {iframe && !display_final && (
                  <RecaptchaComponent
                    iframe={iframe}
                    mobile={mobile}
                    email={email_maitre_ouvrage || ""}
                    actionText="Je suis humain"
                    handleSuccess={() => setDisplayFinal(true)}
                  ></RecaptchaComponent>
                )}
                <div className="flex flex-row justify-end w-full gap-2 mt-4">
                  <SecondaryButton
                    mobile={mobile}
                    onClick={() => setStep("infos-1")}
                  >
                    Retour
                  </SecondaryButton>
                  {(!iframe || display_final) && (
                    <PrimaryButton
                      mobile={mobile}
                      className="w-fit"
                      disabled={
                        false &&
                        available_forms.length > 0 &&
                        forms_filled.length !== available_forms.length
                      }
                      onClick={() => handleCheckToStep("files")}
                    >
                      Générer le brouillon de devis
                    </PrimaryButton>
                  )}
                </div>
              </div>
            )}
            {step === "invoice" && (
              <div className="flex flex-row gap-4 max-w-c500">
                <Space y={20} />
                <div className="text-h3 text-shadow_50">
                  Génération du devis en cours...
                </div>
                <SmallSpinner></SmallSpinner>
              </div>
            )}
            {step === "form" && (
              <div className="w-full flex flex-col justify-start ">
                <NewInvoiceForm
                  mobile={mobile}
                  setStep={setStep}
                  article_configuration={article_configuration}
                  setArticle_configuration={setArticle_configuration}
                ></NewInvoiceForm>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewInvoiceDraft;

export function formatToEuro(amount) {
  // Ensure it's a number
  if (typeof amount === "string") {
    amount = parseFloat(amount); // keep "." for parseFloat
  }
  if (typeof amount !== "number" || isNaN(amount)) {
    return "0,00€";
  }

  // Format with French locale (will use "," as decimal separator automatically)
  const formattedAmount = amount.toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return `${formattedAmount}€`;
}
